import type { WShopLatestProductsTranslations } from "./pl";

export const de: WShopLatestProductsTranslations = {
  title: "Neueste Produkte",
  showAll: "Alle anzeigen",
  noProducts: "Keine Produkte.",
};
